module.exports = __webpack_public_path__ + "static/media/start.773dc3cf.svg";